import { render } from "./DetalleMapa.vue?vue&type=template&id=4e49991b"
import script from "./DetalleMapa.vue?vue&type=script&lang=js"
export * from "./DetalleMapa.vue?vue&type=script&lang=js"

import "./DetalleMapa.vue?vue&type=style&index=0&id=4e49991b&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__